import { FunctionalComponent, h } from 'preact';
import { Button } from '@authentic/loyalty-pwa/components';
import { Box, Typography, link, route } from '@authentic/loyalty-pwa/util';
import { Link } from 'preact-router';
import styled from 'styled-components';
import { SadFaceIcon } from '../icons/SadFace';
import { Helmet } from 'react-helmet';

const PageNotFoundStyle = styled.div`
  background-color: #F6F6F6;
  width: 100%;
  height: 100vh;
  position: relative;
`;
const NotFoundContentStyle = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 552px;
  height: 403px;
  margin-left: -276px;
  margin-top: -232.5px;
  background: white;
  padding: 32px 30px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  svg {
    margin-bottom: 32px;
  }

  a {
    width: 100%;
    margin-top: 24px;
    
  }
  button {
    cursor: pointer;
  }
`;


export const PageNotFound: FunctionalComponent = () => {
  const htmlTitle: string = 'Page Not Found';
  const htmlMetaDescription: string = '';
  const goHome = () => {
    route('/')
  };

  return (
    <PageNotFoundStyle>
      <Helmet>
        <title>{htmlTitle}</title>
        <meta name="description" content={htmlMetaDescription}></meta>
      </Helmet>
      <NotFoundContentStyle>
        <SadFaceIcon></SadFaceIcon>
        <Typography variant="headline1">OH NO!</Typography>
        <Box mb={16} mt={16}>
          <Typography variant="body1">
            It looks like you’ve lost your way.
          </Typography>
        </Box>
        <Link href={link('/sign-in')}>
          <Button ariaLabel="go home" type="button" fullWidth variant="primary" onClick={goHome}>
            GO HOME
          </Button>
        </Link>
      </NotFoundContentStyle>
    </PageNotFoundStyle>
  );
};
